const content: { [key: string]: any } = {
  applicationDetail: 'Application Detail',
};

export default content;
